import { useState } from "react";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import { SxProps, Theme } from "@mui/material/styles";
import { useS3ObjectUrl } from "../api/s3";

/** Аудиозапись из хранилища. Загружается по нажатию: запись блока — несколько
 *  мегабайт, а на странице их несколько. */
export function SecureAudio({ url }: { url: string }) {
  const [requested, setRequested] = useState(false);
  const { src, loading, error } = useS3ObjectUrl(url, requested);

  if (src) {
    /* eslint-disable-next-line jsx-a11y/media-has-caption */
    return <audio controls autoPlay src={src} style={{ width: "100%", marginBottom: 8 }} />;
  }
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 1 }}>
      <Button
        size="small"
        variant="outlined"
        startIcon={loading ? <CircularProgress size={14} /> : <PlayArrowIcon />}
        disabled={loading}
        onClick={() => setRequested(true)}
      >
        Прослушать запись
      </Button>
      {error && (
        <Typography variant="caption" color="error">
          Не удалось загрузить запись
        </Typography>
      )}
    </Box>
  );
}

/** Миниатюра из хранилища как фон блока. */
export function SecureThumb({ url, onClick, sx }: { url: string; onClick?: () => void; sx?: SxProps<Theme> }) {
  const { src } = useS3ObjectUrl(url);
  return (
    <Box
      onClick={onClick}
      sx={[{ backgroundImage: src ? `url(${src})` : "none", backgroundColor: "action.hover" }, ...(Array.isArray(sx) ? sx : [sx])]}
    />
  );
}

/** Изображение из хранилища. */
export function SecureImage({ url, alt, sx }: { url: string; alt: string; sx?: SxProps<Theme> }) {
  const { src, loading } = useS3ObjectUrl(url);
  if (!src) return loading ? <CircularProgress /> : null;
  return <Box component="img" src={src} alt={alt} sx={sx} />;
}
